import React from 'react';

const OffencesManagerSkeleton = () => {
  return (
    <div className="container mx-auto p-6">
      <div className="mb-6">
        <div className="flex justify-between items-center mb-4">
          <div className="h-8 bg-base-200 rounded skeleton animate-pulse w-40"></div>
          <div className="h-10 bg-base-200 rounded skeleton animate-pulse w-32"></div>
        </div>
        
        <div className="card bg-base-100 shadow-sm rounded-2xl p-6 mb-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="text-center p-4 bg-base-50 rounded-lg">
                <div className="h-8 w-8 bg-base-200 rounded skeleton animate-pulse mx-auto mb-2"></div>
                <div className="h-6 bg-base-200 rounded skeleton animate-pulse w-16 mx-auto mb-1"></div>
                <div className="h-4 bg-base-200 rounded skeleton animate-pulse w-20 mx-auto"></div>
              </div>
            ))}
          </div>
          
          <div className="flex gap-3">
            <div className="h-10 bg-base-200 rounded skeleton animate-pulse flex-1"></div>
            <div className="h-10 bg-base-200 rounded skeleton animate-pulse w-24"></div>
          </div>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2">
            <div className="space-y-4">
              {[...Array(6)].map((_, i) => (
                <div key={i} className="card bg-base-100 shadow-sm rounded-2xl p-6">
                  <div className="flex justify-between items-start mb-3">
                    <div className="flex-1">
                      <div className="h-5 bg-base-200 rounded skeleton animate-pulse w-3/5 mb-2"></div>
                      <div className="h-4 bg-base-200 rounded skeleton animate-pulse w-full mb-1"></div>
                      <div className="h-4 bg-base-200 rounded skeleton animate-pulse w-4/5"></div>
                    </div>
                    <div className="h-6 w-16 bg-base-200 rounded skeleton animate-pulse"></div>
                  </div>
                  
                  <div className="flex gap-2">
                    {[...Array(3)].map((_, j) => (
                      <div key={j} className="h-6 px-3 bg-base-200 rounded skeleton animate-pulse w-16"></div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="lg:col-span-1">
            <div className="card bg-base-100 shadow-sm rounded-2xl p-6 sticky top-6">
              <div className="h-6 bg-base-200 rounded skeleton animate-pulse w-3/4 mb-4"></div>
              
              <div className="space-y-3 mb-6">
                {[...Array(4)].map((_, i) => (
                  <div key={i} className="flex items-center justify-between p-2">
                    <div className="h-4 bg-base-200 rounded skeleton animate-pulse w-24"></div>
                    <div className="h-4 bg-base-200 rounded skeleton animate-pulse w-8"></div>
                  </div>
                ))}
              </div>
              
              <div className="space-y-3">
                <div className="h-10 bg-base-200 rounded skeleton animate-pulse w-full"></div>
                <div className="h-10 bg-base-200 rounded skeleton animate-pulse w-full"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OffencesManagerSkeleton;